import { AxiosResponse } from 'axios';
import cacheableRequest from '../../../services/cacheableRequest';
import { Assignment } from '../models/assignment';

export const getTrainingOverview = (userId: string, shouldGetCompleted: boolean) => {
  return cacheableRequest('/v1/trainingOverview?userId=' + userId + (shouldGetCompleted ? '&completed=true' : '')).then(
    ({ data }: AxiosResponse<Assignment[]>) => {
      return data;
    }
  );
};
